import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { StyleDetailsWrapper, StyleScreenWrapper, StyleWrapper } from './style'
import Screen from './screen'
import Details from './details'
const Call = () => {
  const navigate = useNavigate()
  useEffect(() => {
    if (!window.opener) {
      navigate(-1)
    }
  }, [])
  if (!window.opener) return null
  return (
    <StyleWrapper>
      <StyleScreenWrapper>
        <Screen />
      </StyleScreenWrapper>
      <StyleDetailsWrapper>
        <Details />
      </StyleDetailsWrapper>
    </StyleWrapper>
  )
}

export default Call
